<div class="row maap-location-options">
  <div class="col-auto" *ngIf="shouldShowLocationControl('region', regionOptions)">
    <!-- <label for="region">Region</label> -->
    <p-multiSelect 
      id="region"
      (onChange)="onRegionChanged($event)" 
      [filter]="false" 
      optionValue="value" 
      [(ngModel)]="filter.region" 
      [options]="regionOptions" 
      class="noHeader">
    </p-multiSelect>
  </div>
  <div class="col-auto" *ngIf="shouldShowLocationControl('campus', campusOptions)">
    <!-- <label for="campus">Campus</label> -->
    <p-multiSelect 
      id="campus"
      (onChange)="onCampuseChanged($event)" 
      [filter]="false" 
      optionValue="value" 
      [(ngModel)]="filter.campus" 
      [options]="campusOptions" 
      class="noHeader">
    </p-multiSelect>
  </div>
  <div class="col-auto" *ngIf="shouldShowLocationControl('facility', facilityOptions)">
    <!-- <label for="facility">Facility</label> -->
    <p-multiSelect 
      id="facility"
      (onChange)="onFacilitieChanged($event)" 
      [filter]="true" 
      optionValue="value" 
      [(ngModel)]="filter.facility" 
      [options]="facilityOptions" 
      class="multiSelectStyle">
      <ng-template let-option pTemplate="item">
        {{ option.label }}
      </ng-template>
      <ng-template let-option pTemplate="selectedItem">
        {{ option.label }}
      </ng-template>
    </p-multiSelect>
  </div>
  <div class="col-auto" *ngIf="shouldShowLocationControl('locationGroup', locationGroupOptions)">
    <p-multiSelect 
      id="locationGroup"
      (onChange)="onlocationGroupChanged($event)" 
      [filter]="true"
      optionValue="value"
      [(ngModel)]="filter.locationGroup"
      [options]="locationGroupOptions"
      class="multiSelectStyle">
      <ng-template let-option pTemplate="item">
        {{ option.label }}
      </ng-template>
      <ng-template let-option pTemplate="selectedItem">
        {{ option.label }}
      </ng-template>
    </p-multiSelect>
  </div>
  <div class="col-auto ms-auto" *ngIf="shouldShowReset()">
    <span class="refresh-btn">
      <p-button icon="pi pi-refresh" styleClass="p-button-secondary" (click)="onClickReset()" 
                pTooltip="Reset" tooltipPosition="bottom">
      </p-button>
    </span>
  </div>
</div>
